var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.981,
    height: 21,
    viewBox: "0 0 20.981 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "settings-solid",
    d: "M22.7,11.48l-2.233-.667a7.766,7.766,0,0,0-.633-1.553L20.93,7.213a.407.407,0,0,0-.073-.48l-1.593-1.6a.407.407,0,0,0-.48-.073L16.75,6.147a7.747,7.747,0,0,0-1.573-.667L14.51,3.273A.407.407,0,0,0,14.117,3H11.863a.407.407,0,0,0-.387.287l-.667,2.2a7.753,7.753,0,0,0-1.587.667l-2-1.08a.407.407,0,0,0-.48.073l-1.62,1.58a.407.407,0,0,0-.073.48l1.08,2a7.753,7.753,0,0,0-.667,1.58l-2.207.667a.407.407,0,0,0-.287.387v2.253a.407.407,0,0,0,.287.387l2.22.667A7.747,7.747,0,0,0,6.143,16.7L5.05,18.793a.407.407,0,0,0,.073.48l1.593,1.593a.407.407,0,0,0,.48.073l2.06-1.1a7.767,7.767,0,0,0,1.533.627l.667,2.247a.407.407,0,0,0,.387.287H14.1a.407.407,0,0,0,.387-.287l.667-2.253a7.753,7.753,0,0,0,1.52-.627l2.073,1.107a.407.407,0,0,0,.48-.073l1.593-1.593a.407.407,0,0,0,.073-.48l-1.107-2.067a7.753,7.753,0,0,0,.633-1.527l2.247-.667a.407.407,0,0,0,.287-.387V11.873a.407.407,0,0,0-.247-.393ZM12.99,16.667A3.667,3.667,0,1,1,16.657,13a3.667,3.667,0,0,1-3.667,3.667Z",
    transform: "translate(-2.47 -2.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4fddd7b74036793835bc166db5e33f2c.svg";
export { ForwardRef as ReactComponent };